type RestartType = {
  Restart(): void;
  restart(): void;
};

export default {
  Restart(): void {
    window.location.reload();
  },
  restart(): void {
    window.location.reload();
  },
} as RestartType;
